import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { ROUTESLIST } from "@/static/urls";
import FrontBanner from "@/assets/images/front-banner.svg";

import clearIcon from "../../assets/images/home/clearIcon.svg";
import assessIcon from "../../assets/images/home/assessIcon.svg";
import licensesIcon from "../../assets/images/home/licensesIcon.svg";

import { withAuth0 } from "@auth0/auth0-react";
import { bindActionCreators } from "redux";
import { getToken } from "@/actions/auth";
import OurClients from "../../components/our-clients";

import "./home.scss";
import Testimonials from "@/components/testimonials";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth, // Set initial window width
      claims: "", // Initialize claims
    };
    this.constant = [
      {
        title: "SAMPLE & SYNC CLEARANCE",
        icon: clearIcon,
        src: "https://www.youtube.com/embed/5hqbvLuArkE",
        description:
          "Ample Samples™ streamlines sample clearance and sync licensing with expert copyright research, rights-holder identification, negotiation, and agreement management—so your music, film, TV, or brand project gets cleared fast and accurately.",
      },
      {
        title: "SAMPLE REVIEW",
        icon: assessIcon,
        src: "https://www.youtube.com/embed/xTYYTV6R93k",
        description:
          "Before you release, know the cost. We review your music, flag potential samples, and explain clearance options early.",
      },
      {
        title: "DIGITAL LICENSES",
        icon: licensesIcon,
        // src: "https://www.youtube.com/embed/KyFS0PfRynY?si=ScGX-rzjF6SHjBjS",
        src: "https://www.youtube.com/embed/8JEEQ9lqwUk",
        description:
            "Ample Samples™ helps artists and creators obtain the proper approvals to re-record songs and pair them with visual content, so your release is cleared and monetizable.",
      },
      {
        title: "PLACING YOUR SONGS AND TRACKS",
        icon: licensesIcon,
        // src: "https://www.youtube.com/embed/KyFS0PfRynY?si=ScGX-rzjF6SHjBjS",
        src: "https://www.youtube.com/embed/pf1UAqJDWJg",
        description:
          "If you own your rights we’ll help you place your recordings and compositions and get paid on site. - info@thesampl.es",
      },
    ];
    this.state = {
      claims: "",
      redirectToSubscription: false,
    };
  }

  componentDidMount() {
    // const token = localStorage.getItem("token");
    window.addEventListener("resize", this.handleResize); // Listen for resize events when component mounts
    this.handleResize();
    // if (token) {
    //   token?.length && this.props?.getToken(token);
    // }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize); // Clean up event listener when component unmounts
    this.setState({
      redirectToSubscription: false,
    });
  }

  handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth, // Update the window width in state
    });
  };

  render() {
    // const token = localStorage.getItem("token");
    const { redirectToSubscription, windowWidth } = this.state;
    // const { auth } = this.props;

    if (redirectToSubscription) return <Redirect to={ROUTESLIST.SIGNUP} />;

    return (
      <main className="page">
        {/* <section className="home-banner">
          <div className="content">
            <h2 className="head-shadow">Ample Samples</h2>
            <h3 className="head">Clear your samples quickly & accurately</h3>
            <div className="home-banner__quote">
              <p>
                "It is perfectly obvious to the listener that in musical terms, the two songs are
                virtually identical."
              </p>
              <div className="home-banner__quote-author">– Judge Richard Owen</div>
            </div>
            <div className="home-banner__info">
              <p>
                In August of 1976 Judge Richard Owen found that George Harrison’s #1 hit,
                “My Sweet Lord”, had subconsciously infringed on the copyright of “He’s So Fine”
                by The Chiffons. Harrison was forced to fork over nearly $1.6M in
                earnings to the publishers of “He’s So Fine” as a result.
              </p>
              <p>
                <strong>Bright Tunes Music Corp.</strong> v. <strong>Harrisongs Music, Ltd.</strong> was the first of the music
                industry’s major infringement lawsuits. Don’t let assumptions or errors in your sample
                clearance process lead your song or project to become one of the latest releases to hold
                such an unceremonious honor.
              </p>
            </div>
            <div className="home-banner__btns">
              <Link className="btn btn-primary" to={ROUTESLIST.CLEAR_SAMPLE}>Clear Your Samples!</Link>
            </div>
          </div>
        </section>
        <section className="home-section home-section_right-img">
          <div className="home-section__col">
            <div className="home-section__text">
              <div className="home-section__wrap">
                <h3 className="home-section__title">How it Works?</h3>
                <div className="home-section__body">
                  <p>
                    Create an account and follow our four easy steps as part of engaging Ample Samples™
                    to begin clearing the sample or samples in your new song(s).
                  </p>
                  <p>
                    Make and initial payment for our services and the clearance process
                    for your project will begin.
                  </p>
                  <p>
                    We will negotiate based on your budget and the nature of your sample use
                    and update you as the clearances for your project progresses from start
                    to finish.
                  </p>
                </div>
                <footer className="home-section__btns">
                  {token
                    ? <Link className="btn btn-primary" to={ROUTESLIST.CLEAR_SAMPLE}>START NOW</Link>
                    : <Link className="btn btn-primary" to={ROUTESLIST.SIGNUP}>START NOW</Link>
                  }
                </footer>
              </div>
            </div>
          </div>
          <div className="home-section__col">
            <div className="home-section__img" id="home-section-bg1"></div>
          </div>
        </section> */}

        <div className="banner-section">
          <div className="front-banner">
            <div className="banner-section1">
              <h3 className="front-header">CLEAR YOUR MUSIC AND SAMPLES QUICKLY AND ACCURATELY!</h3>
              {/* <p className="front-paragraph">
                Join Ample Samples to streamline your music sample clearance and
                assessment and to unlock access to premier production licensing
                opportunities
              </p> */}
              <p className="front-paragraph">
                Join Ample Samples™ to simplify sample clearance, music
                licensing and sample identification—so you can focus on
                creating. Plus, unlock exclusive production licensing
                opportunities to take your music to the next level!
              </p>
            </div>
            <div className="banner-section2">
              <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="front-banner" />
            </div>
          </div>
        </div>
        {/* <div className="content">
          <div className="review-video">
            <div className="review-video__inner">
              <iframe
                src="https://www.youtube.com/embed/5hqbvLuArkE?autoplay=0"
                title="YouTube video player"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                width="100%"
                height="100%"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div> */}
        <div className="main-video-section">
          {this.constant.map((details, index) => {
            return (
              <div
                key={index}
                className={`row`}
                style={
                  index % 2 === 1 && windowWidth >= 769
                    ? { flexDirection: "row-reverse" }
                    : null
                }
              >
                <div className="row-video">
                  <iframe
                    src={details?.src}
                    title="YouTube video player"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    width="100%"
                    height="100%"
                    allowFullScreen
                  />
                </div>
                <div className="row-content">
                  <div className="content-title">
                    <img src={details.icon}  alt={details.title}/>
                    <h1>{details.title}</h1>
                  </div>
                  <p className="content-description">{details.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="content">
          <div className="joinnow-section joinnow-section--newsletter">
            <h1>Get smarter about music clearance – and save thousands!</h1>
            <p>
              We aim to educate and motivate. Join our newsletter.
            </p>
            <button
              className="btn btn-primary btn-fw"
              onClick={() => {
                window.open("https://www.newsletter.theamplesamples.com/", "_blank", "noopener,noreferrer");
              }}
            >
              STAY IN THE LOOP
            </button>
          </div>
        </div>
          
        <div className="content">
          <div className="joinnow-section">
            <h1>Why Choose Ample Samples™?</h1>
            <p>
              At Ample Samples™, we understand the complexities and challenges
              faced by music creators, producers, and media companies when it
              comes to licensing and clearing samples. Our all-in-one solution
              streamlines this process, allowing you to focus on your creativity
              while we handle the legal intricacies.
            </p>
            <button
              className="btn btn-primary btn-fw"
              onClick={() => {
                // history.push("/signup")
                this.setState({
                  redirectToSubscription: true,
                });
              }}
            >
              Join Now
            </button>
          </div>
        </div>
        <Testimonials />
        <OurClients />
        {/* <SocialSticky /> */}
      </main>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToken,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth0(HomePage));
/*
<section className="home-section home-section_left-img">
    <div className="content">
        <h2 className="head-shadow">Ample Samples</h2>
        <h3 className="head">Clear your samples quickly & accurately</h3>
    </div>
</section>
mklink /d "d:\OpenServer\domains\as1.loc\backend\public\assets" "d:\OpenServer\domains\as1.loc\frontend\public\assets"
*/
